const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'paymentModel',
      label: 'Model płatności',
      column: 1,
      type: 'radioGroupEnum',
      enumType: 'enums/paymentModel',

      mandatory: true,
      options: [
        'FULL_PAYMENT_ON_BOOKING',
        'PARTIAL_PAYMENT',
        'FULL_PAYMENT_ON_CHECKIN'
      ]
    },
    {
      name: 'paymentTypeOnBooking',
      label: 'Rodzaj płatności przy rezerwacji',
      column: 1,
      type: 'radioGroupDictionary',
      dictionary: 'paymentType',
      mandatory: true,
      conditionalOn: 'paymentModel',
      conditionalOnMatchValue: ['PARTIAL_PAYMENT', 'FULL_PAYMENT_ON_BOOKING']
    },

    {
      name: 'paymentTypeOnCheckin',
      label: 'Rodzaj płatności przy zameldowaniu',
      column: 1,
      type: 'radioGroupDictionary',
      mandatory: true,
      dictionary: 'paymentType',
      conditionalOn: 'paymentModel',
      conditionalOnMatchValue: ['PARTIAL_PAYMENT', 'FULL_PAYMENT_ON_CHECKIN']
    },

    {
      name: 'paymentDueOnBooking',
      label: 'Termin płatności przy rezerwacji',
      column: 1,
      type: 'date',
      mandatory: true,
      conditionalOn: 'paymentModel',
      customCondition: function(paymentModel, formData) {
        return ['PARTIAL_PAYMENT', 'FULL_PAYMENT_ON_BOOKING'].includes(paymentModel)

        && formData.paymentTypeOnBooking?.value !== 'PAYMENT_SYSTEM'

      },
      wrapWithEditableSection: true
    },
    {
      name: 'paymentDueOnCheckin',
      label: 'Termin płatności przy zameldowaniu',
      column: 1,
      type: 'date',
      mandatory: true,
      conditionalOn: 'paymentModel',
      conditionalOnMatchValue: ['PARTIAL_PAYMENT', 'FULL_PAYMENT_ON_CHECKIN'],
      wrapWithEditableSection: true
    },
    {
      name: 'paymentTypeDeposit',
      label: 'Rodzaj płatności kaucji',
      column: 1,
      type: 'radioGroupDictionary',
      mandatory: true,
      dictionary: 'paymentType',
    },
  ]
};

export default fields;
